import CircleMaskReveal from 'app/display/transitions/CircleMaskReveal';
import PolygonMaskReveal from 'app/display/transitions/PolygonMaskReveal';
import RectMaskReveal from 'app/display/transitions/RectMaskReveal';
import LowFi from 'app/display/transitions/LowFi';

class Transitions extends Phaser.Sprite {
  constructor({ game, enabled }) {
    super(game);
    this.enabled = enabled;
    this.onTransitionInComplete = new Phaser.Signal();
    this.onTransitionOutComplete = new Phaser.Signal();
  }

  /*
  ===========================================================================
      START
  ===========================================================================
  */
  startTransition({ type = Transitions.POLY_MASK }) {
    this.game.stage.addChild(this);

    if (this.enabled) {
      switch (type) {
        case Transitions.CIRCLE_MASK:
          this.transition = new CircleMaskReveal({ game: this.game });
          break;
        case Transitions.POLY_MASK:
          this.transition = new PolygonMaskReveal({ game: this.game });
          break;
        case Transitions.RECT_MASK:
          this.transition = new RectMaskReveal({ game: this.game });
          break;
        case Transitions.LOW_FI:
          this.transition = new LowFi({ game: this.game });
          break;
        default:
          this.transition = new LowFi({ game: this.game });
      }
      this.addChild(this.transition);
    }
    if (this.transition) {
      this.transitionStart();
      this.game.scale.onSizeChange.add(this.positionElements, this);
      this.positionElements();
    } else {
      // this triggers a state switch
      this.onTransitionInComplete.dispatch();
    }
  }

  positionElements() {
    // this.scale.set(this.game.aspectScale);
    // this.x = this.game.width / 2 - this.game.defaultWidth * this.game.aspectScale / 2;

    const x = (this.game.width - this.game.defaultWidth) * 0.5;
    const y = (this.game.height - this.game.defaultHeight) * 0.5;
    this.position.set(x, y);
  }

  /*
  ===========================================================================
      Tweening
  ===========================================================================
  */

  transitionStart() {
    this.transition.onInComplete.addOnce(this.transitionInComplete, this);
    this.transition.onOutComplete.addOnce(this.transitionOutComplete, this);
    this.transition.init();
    this.transition.startIn(0);
  }

  transitionInComplete(tran) {
    if (tran) {
      tran.onInComplete.removeAll();
    }
    this.onTransitionInComplete.dispatch();
  }

  // transition screen has entered and waiting to be told to exit
  transitionEnd() {
    if (this.transition) {
      this.transition.startOut();
    } else {
      this.transitionOutComplete();
    }
  }

  transitionOutComplete(tran) {
    if (tran) {
      tran.onOutComplete.removeAll();
    }
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    this.onTransitionOutComplete.dispatch();
  }

  /*
  ===========================================================================
      Clean Up
  ===========================================================================
  */
  destroy() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);

    this.game.tweens.removeFrom(this, true);
    this.game.tweens.removeFrom(this);

    //clear signal
    this.onTransitionOutComplete.forget();
    this.onTransitionOutComplete.dispose();
    this.onTransitionOutComplete.removeAll();

    this.onTransitionInComplete.forget();
    this.onTransitionInComplete.dispose();
    this.onTransitionInComplete.removeAll();

    if (this.transition) {
      this.transition.destroy();
    }
    this.transition = null;
    // bye bye
    super.destroy(true);
  }
}

Transitions.CIRCLE_MASK = 'CIRCLE_MASK'; // doesnt work!!! Using POLY_MASK instaed
Transitions.POLY_MASK = 'POLY_MASK';
Transitions.RECT_MASK = 'RECT_MASK';
Transitions.LOW_FI = 'LOW_FI';
export default Transitions;
